import { combineReducers } from 'redux';
import { reducer as oidcReducer } from 'redux-oidc';
import settings from './settings/reducer';
import menu from './menu/reducer';
import authUser from './auth/reducer';
import chatListApp from './chatList/reducer';
import availablityListApp from './availablity/reducer';
import bookingListApp from './bookings/reducer';
import ticketListApp from './ticketList/reducer';
import usersListApp from './users/reducer';
import createTicket from './createTicket/reducer';
import signalRConnection from './signalr/reducer';
import serviceReducer from './service/reducer';
import twilioConversationsReducer from './twilioConversations/reducer';

const reducers = combineReducers({
  oidc: oidcReducer,
  menu,
  settings,
  authUser,
  chatListApp,
  availablityListApp,
  bookingListApp,
  ticketListApp,
  usersListApp,
  createTicket,
  signalRConnection,
  service: serviceReducer,
  twilioConversationsReducer,
});

export default reducers;
